import MainStore from "@/store";
import MainRouter from "@/router";

import localStore from "./store";
import localRoutes from "./router";

MainStore.registerModule("endorsement", localStore);
MainRouter.addRoutes(localRoutes);
